module.exports = __webpack_public_path__ + "img/header.3193a43a.jpg";